/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface JournalEntry
 */
export interface JournalEntry {
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof JournalEntry
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JournalEntry
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'invalidTaxCodeCause': JournalEntryInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JournalEntry
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof JournalEntry
     */
    'description': string | null;
}

export const JournalEntryInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type JournalEntryInvalidTaxCodeCauseEnum = typeof JournalEntryInvalidTaxCodeCauseEnum[keyof typeof JournalEntryInvalidTaxCodeCauseEnum];


